import { render, staticRenderFns } from "./counter.vue.js?vue&type=template&id=0840a368!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=template&id=0840a368"
import script from "./counter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0840a368')) {
      api.createRecord('0840a368', component.options)
    } else {
      api.reload('0840a368', component.options)
    }
    module.hot.accept("./counter.vue.js?vue&type=template&id=0840a368!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=template&id=0840a368", function () {
      api.rerender('0840a368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/counter.vue"
export default component.exports